module.exports = __webpack_public_path__ + "media/newstyle/images/icon-epub-6d943cf2e1511eb078dd44df6bc0103c.svg";